import type { Pathname } from 'history';

export function getPathSegmentsFromPathname(pathname: Pathname): string[] {
  // Remove empty strings from the path
  return pathname.split('/').filter(segment => segment.length > 0);
}
